import { useQuery, UseQueryResult } from '@tanstack/react-query'
import axios from 'axios'

import { CacheKeys } from '../lib/cache'
import { toCamelCase } from '../lib/typeHelper'

export interface VinAttribute {
  variable: string
  value: string
}

export interface VinParsedEquipment {
  make?: string
  model?: string
  year?: number
  vehicleClass?: string
  weightClass?: string
  isTrailer?: boolean
}

export interface VinLookupResponse {
  vin: string
  attributes: VinAttribute[]
  parsed: VinParsedEquipment
  errorCode: string | null
  errorText: string | null
}

function fetchVinLookup(vin: string): Promise<VinLookupResponse> {
  return axios
    .get(`/api/v1/insure/internal/vin/${vin}/`)
    .then((response) => toCamelCase(response.data) as VinLookupResponse)
}

export function useVinLookup(vin: string | undefined): UseQueryResult<VinLookupResponse> {
  return useQuery({
    queryKey: [CacheKeys.VIN_LOOKUP, vin],
    queryFn: () => fetchVinLookup(vin!),
    enabled: !!vin,
    retry: false,
  })
}
